import {
  FarmboxRawMaterials,
  FarmboxRawMaterialsData,
} from 'models/FarmboxRawMaterials/farmBoxRawMaterials.model';

export const stage1InitialData = async (
  commodityId: number,
  getRawMaterials: (commodityId: number) => Promise<FarmboxRawMaterialsData>
) => {
  const initialValues: FarmboxRawMaterialsData = await getRawMaterials(
    Number(commodityId)
  );
  const areAllArraysEmpty =
    !initialValues?.fertilizers?.[0]?.activityLabel &&
    !initialValues?.packagings?.[0]?.activityLabel;

  return !areAllArraysEmpty
    ? {
        ...initialValues,
        fertilizers: initialValues?.fertilizers?.length
          ? initialValues?.fertilizers
          : [new FarmboxRawMaterials()],
        packagings: initialValues?.packagings?.length
          ? initialValues?.packagings
          : [],
      }
    : new FarmboxRawMaterialsData();
};
